'use client';

import { createIcon } from '@chakra-ui/react';

const SearchIconWithCreateIcon = createIcon({
  displayName: 'SearchIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="currentColor"
      d="M21.71 20.29L18 16.61A9 9 0 1 0 16.61 18l3.68 3.68a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.39zM11 18a7 7 0 1 1 7-7 7 7 0 0 1-7 7z"
    />
  ),
});

export const SearchIcon = () => (
  <SearchIconWithCreateIcon boxSize="24px" color="currentColor" />
);
const UserIconWithCreateIcon = createIcon({
  displayName: 'UserIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g clipPath="url(#clip0_4597_226)">
        <path
          fill="currentColor"
          d="M12 21C7.0293 21 3 16.9707 3 12C3 7.0293 7.0293 3 12 3C16.9707 3 21 7.0293 21 12C21 16.9707 16.9707 21 12 21ZM7.5117 17.6304C8.78569 18.6489 10.3689 19.2026 12 19.2C13.773 19.2 15.3957 18.5592 16.6503 17.4972C16.0642 16.8958 15.3633 16.418 14.5893 16.0921C13.8153 15.7663 12.9838 15.5989 12.144 15.6C11.2733 15.599 10.412 15.779 9.61452 16.1285C8.81708 16.478 8.101 16.9895 7.5117 17.6304ZM6.2544 16.338C7.01081 15.5353 7.9236 14.8959 8.93652 14.4594C9.94945 14.0229 11.041 13.7985 12.144 13.8C13.2075 13.7986 14.2608 14.0073 15.2434 14.4141C16.226 14.821 17.1185 15.4179 17.8698 16.1706C18.6403 15.0862 19.0953 13.8096 19.1843 12.4823C19.2733 11.1551 18.993 9.8291 18.3742 8.65151C17.7555 7.47392 16.8227 6.49076 15.6792 5.8111C14.5357 5.13144 13.2262 4.78185 11.8961 4.80113C10.566 4.8204 9.26729 5.20778 8.14397 5.92028C7.02064 6.63279 6.11666 7.64256 5.53232 8.83758C4.94798 10.0326 4.70612 11.3661 4.83358 12.6903C4.96104 14.0144 5.45284 15.2773 6.2544 16.3389V16.338ZM12 12.9C11.0452 12.9 10.1295 12.5207 9.45442 11.8456C8.77928 11.1705 8.4 10.2548 8.4 9.3C8.4 8.34522 8.77928 7.42955 9.45442 6.75442C10.1295 6.07928 11.0452 5.7 12 5.7C12.9548 5.7 13.8705 6.07928 14.5456 6.75442C15.2207 7.42955 15.6 8.34522 15.6 9.3C15.6 10.2548 15.2207 11.1705 14.5456 11.8456C13.8705 12.5207 12.9548 12.9 12 12.9ZM12 11.1C12.4774 11.1 12.9352 10.9104 13.2728 10.5728C13.6104 10.2352 13.8 9.77739 13.8 9.3C13.8 8.82261 13.6104 8.36477 13.2728 8.02721C12.9352 7.68964 12.4774 7.5 12 7.5C11.5226 7.5 11.0648 7.68964 10.7272 8.02721C10.3896 8.36477 10.2 8.82261 10.2 9.3C10.2 9.77739 10.3896 10.2352 10.7272 10.5728C11.0648 10.9104 11.5226 11.1 12 11.1Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_4597_226">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </>
  ),
});

export const UserIcon = () => (
  <UserIconWithCreateIcon boxSize="24px" color="currentColor" />
);

const LanguageIconWithCreateIcon = createIcon({
  displayName: 'LanguageIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="currentColor"
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
    />
  ),
});

export const LanguageIcon = () => (
  <LanguageIconWithCreateIcon boxSize="24px" color="currentColor" />
);

const DownloadIconWithCreateIcon = createIcon({
  displayName: 'DownloadIcon',
  viewBox: '0 0 24 24',
  path: (
    <path fill="currentColor" d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
  ),
});

export const DownloadIcon = () => (
  <DownloadIconWithCreateIcon boxSize="24px" color="currentColor" />
);
